<template>
  <div id="app" :class="vueAppClasses" ref="app">
    <transition name="fade" mode="out-in">
      <router-view @setAppClasses="setAppClasses"/>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  watch: {
    '$vs.rtl'(val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  computed: {
    vueAppClasses() {
      return this.$store.state.AppClasses
    }
  },
  methods: {
    setAppClasses(classesStr) {
      this.$store.commit('SET_APP_CLASSES', classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
      this.$store.commit('UPDATE_WINDOW_HEIGHT', window.innerHeight)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    refreshScrollTrigger: _.debounce(function () {
      if (this.$store.state.windowWidth && window.innerWidth !== this.$store.state.windowWidth) {
        // window.webkitRequestAnimationFrame()
        // window.requestAnimationFrame()
        // this.$gsap.killAll()
        document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
      }
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
      this.$store.commit('UPDATE_WINDOW_HEIGHT', window.innerHeight)

      // Set --vh property
      // document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    }, 300),
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted() {
    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    this.handleWindowResize()
    this.handleScroll()
  },
  async created() {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.refreshScrollTrigger)
    // window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    // window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.refreshScrollTrigger)
  }
}

</script>
